module.exports = __webpack_public_path__ + "img/bars.2eb9c8cd.svg";